<div class="app-wrapper">
  <div class="app-content">
    <router-outlet />
  </div>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-row">
        <span>{{ 'FOOTER.TUEN_MUN' | translate }}</span>
        <span>{{ 'FOOTER.TEL' | translate }}2454 9961</span>
        <span>{{ 'FOOTER.EMAIL' | translate }}info&#64;rda.org.hk</span>
      </div>
      <div class="footer-row">
        <span>{{ 'FOOTER.POKFULAM' | translate }}</span>
        <span>{{ 'FOOTER.TEL' | translate }}2875 7711</span>
        <span>{{ 'FOOTER.EMAIL' | translate }}infopfl&#64;rda.org.hk</span>
      </div>
      <div class="footer-row">
        <span>{{ 'FOOTER.WEBSITE' | translate }}www.rda.org.hk</span>
        <span>{{ 'FOOTER.CHARITY_REG' | translate }}91/1615</span>
      </div>
      <div class="footer-divider"></div>
      <div class="footer-copyright">
        <div>{{ 'FOOTER.COPYRIGHT' | translate }}</div>
      </div>
    </div>
  </footer>
</div>
@defer {
  <app-notification-modal></app-notification-modal>
}
